/* eslint-disable */

import Vue from 'vue';
import {createApp} from 'vue'
import router from './router';
import store from './store/index';

// import AsyncComputed from 'vue-async-computed'
// Vue.use(AsyncComputed);

import Amplify from 'aws-amplify';
import awsconfig from './aws-exports';

import {Auth, API, Logger} from "aws-amplify";

// import VueQrcode from '@chenfengyuan/vue-qrcode';
// Vue.component(VueQrcode.name, VueQrcode);

Amplify.configure(awsconfig);

// Vue.use(Auth);
// Vue.use(API);

Logger.LOG_LEVEL = "DEBUG";

// const logger = new Logger("main");

// Vue.config.productionTip = false

// export const bus = new Vue();

import {createI18n} from 'vue-i18n'
import messages from './messages'

const i18n = createI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: messages,
})

// new Vue({
//     el: '#app',
//     // i18n,
//     router,
//     store,
//     template: '<App/>',
//
//     components: {
//         app: App
//     },
//
//     render: h => h('app'),
//     mounted() {
//         this.$router.replace('/').catch(err => {});
//     }
// })

import mitt from 'mitt'

const emitter = mitt()

import App from './App.vue';

const app = createApp(App)
app.use(router)
app.use(store)

app.use(Auth)
app.use(API)
app.use(i18n)

app.config.globalProperties.emitter = emitter
app.mount('#app')
